import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { useUser } from "lib/user/use-user"
import { Box, Typography } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"

export function JustificationUpdatedBy({ payload }) {
    const { createdOn, createdBy } = useBoundContext()

    const { reasonBy, reasonDate } = payload
    const { user = {} } = useUser(reasonBy)

    const userName = reasonBy ? user?.displayName || user?.email : createdBy
    const updatedDate = reasonBy ? new Date(reasonDate).format(DATE_FORMATS.long) : createdOn

    return (
        <If value={userName}>
            <Box display="flex" alignItems="center">
                <TruncatedTypography
                    variant="caption"
                    sx={{
                        color: "text.secondary",
                        fontWeight: "bold",
                        minWidth: 0,
                    }}
                >
                    {userName}
                </TruncatedTypography>
                <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: "bold" }}>
                    ,
                </Typography>
                <Typography variant="caption" sx={{ color: "text.secondary", flexShrink: 0, ml: 0.5 }}>
                    {updatedDate}
                </Typography>
            </Box>
        </If>
    )
}
